import PropTypes from "prop-types";
import Arrow from "@Decix.Icons/cta-arrow-secondary.svg";

export default function CtaSecondary({ href, children, className, ...props }) {
    const text = <span className="cta__text">{children}</span>;
    const finalClassName = "cta cta--secondary" + (className ? " " + className : "");

    if (href) {
        return (
            <a href={href} className={finalClassName} {...props}>
                {text}
                <Arrow />
            </a>
        );
    }

    return (
        <button className={finalClassName} {...props}>
            {text}
            <Arrow />
        </button>
    );
}

CtaSecondary.propTypes = {
    href: PropTypes.string,
    className: PropTypes.string,
    children: PropTypes.node.isRequired,
};
